import { createRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { LoginForm } from "@/components/auth/LoginForm";
import { trpcClient } from "@/lib/trpc";
import { rootRoute } from "./rootRoute";

export const loginRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/login",
    validateSearch: z
        .object({
            invitation: z.string().optional(),
            redirect: z.string().optional(),
            email: z.string().optional(),
        })
        // Allow OAuth/MCP query params (client_id, redirect_uri, ...) to pass through
        // so the LoginForm can forward them back to /api/auth/oauth2/authorize.
        .passthrough(),
    beforeLoad: async ({ search }) => {
        const { invitation } = search;

        let invitationData: any;
        if (invitation) {
            invitationData = await trpcClient.auth.getInvitation.query({ id: invitation });
        }

        return {
            invitation: invitationData,
        };
    },
    component: () => {
        const { invitation } = loginRoute.useRouteContext() as { invitation: any };
        return (
            <AuthLayout>
                <LoginForm invitation={invitation} />
            </AuthLayout>
        );
    },
});
